/**
 * @file OperationsEquipmentPage.jsx
 * @description OPERATIONS department — Equipments.
 *
 * Equipment list in the operations guise: last engine-on / last GPS-on instead of last-seen.
 *
 * This file belongs to the OPERATIONS department. Departments never share page
 * files: each department's top-bar header mounts its OWN file (this one), so
 * a change for OPERATIONS is made HERE and can never leak into another
 * department's screens. The shared engine underneath (EquipmentPage) and the backend
 * stay common — only the department-facing page is departmental. Route access
 * is department-gated in utils/permissions.js: only OPERATIONS users (and the
 * super admin) can open it.
 */
import React from 'react';
import EquipmentPage from '../EquipmentPage';

const OperationsEquipmentPage = () => (<EquipmentPage variant="operations" />);

export default OperationsEquipmentPage;
